import React from 'react';

export const ProcessStep: React.FC<{
  number: number;
  title: string;
  description: string;
}> = ({ number, title, description }) => (
  <div className="flex mb-8">
    <div className="flex-shrink-0 mr-4">
      <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold">
        {number}
      </div>
    </div>
    <div>
      <h4 className="text-xl font-medium mb-2 dark:text-white">{title}</h4>
      <p className="text-zinc-600 dark:text-zinc-300">{description}</p>
    </div>
  </div>
);
